import { defineMessages } from 'react-intl';

export default defineMessages({
    doingRateMessage: {
        id: 'rewrite.eh.views.riskAnalysis.Please wait while we rate your policy...',
        defaultMessage: 'Please wait while we rate your policy...'
    },
    lossesAndViolationTabHeading: {
        id: 'rewrite.eh.views.riskAnalysis.lossesAndViolation.Losses',
        defaultMessage: 'Losses'
    },
    miscellaneaousReportsTabHeading: {
        id: 'rewrite.eh.views.riskAnalysis.miscellaneaousReports.Miscellaneous Reports',
        defaultMessage: 'Miscellaneous Reports'
    },
    creditTabHeading: {
        id: 'rewrite.eh.views.riskAnalysis.credit.Credit',
        defaultMessage: 'Credit'
    },
    premium: {
        id: 'rewrite.eh.views.riskAnalysis.premium.Premium',
        defaultMessage: 'Premium'
    }
});
